<div class="buttons-container" 
style="display: flex; justify-content: end;
right: 45px;
    position: fixed;
    top: 70px;z-index: 2; ">
  <div class="buttons" id="code-buttons">
<dx-button
icon="save"
type="success"
text="Güncelle"
class="margin"
(onClick)="save()"
></dx-button>

</div></div>


<div class="container">
  <h2 class="content-block">Hizmet ve Kullanım Sözleşmesi</h2>
<div class="content-block card responsive-paddings">
  <label span class="dx-field-item-label-text">Başlık</label>
  <dx-text-box
    [(value)]="termsAndConditions.title"
    labelMode="floating"
    [maxLength]="100"
  >
  </dx-text-box>
  <br />
    <label span class="dx-field-item-label-text">MetaKeyword</label>
    <dx-text-box
      [(value)]="termsAndConditions.metaKeyword"
      labelMode="floating"
    >
    </dx-text-box>
    <br />
    <label span class="dx-field-item-label-text">MetaDescription</label>
    <dx-text-box
      [(value)]="termsAndConditions.metaDescription"
      labelMode="floating"
    >
    </dx-text-box>
  <br />
  <app-image-uploader
      (fileSelected)="onFileSelectedTermsAndConditions($event)"
      [src]="termsAndConditions.imageUrl"
    ></app-image-uploader>
    <br />
  <dx-html-editor [(value)]="termsAndConditions.content" style="height: 300px;">
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item
        name="size"
        [acceptedValues]="[
          '8pt',
          '9pt',
          '10pt',
          '12pt',
          '14pt',
          '18pt',
          '24pt',
          '36pt'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
      ></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
      ></dxi-item>
      <dxi-item
        name="header"
        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
      ></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item widget="dxButton" [options]="toolbarButtonOptionsTermsAndConditions"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>
</div>

<h2 class="content-block">Aydınlatma Metni</h2>
<div class="content-block card responsive-paddings">
  <label span class="dx-field-item-label-text">Başlık</label>
  <dx-text-box
    [(value)]="clarificationText.title"
    labelMode="floating"
    [maxLength]="100"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaKeyword</label>
  <dx-text-box
    [(value)]="clarificationText.metaKeyword"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaDescription</label>
  <dx-text-box
    [(value)]="clarificationText.metaDescription"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
    <app-image-uploader
      (fileSelected)="onFileSelectedClarificationText($event)"
      [src]="clarificationText.imageUrl"
    ></app-image-uploader>
    <br />
  <dx-html-editor [(value)]="clarificationText.content" style="height: 300px;">
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item
        name="size"
        [acceptedValues]="[
          '8pt',
          '9pt',
          '10pt',
          '12pt',
          '14pt',
          '18pt',
          '24pt',
          '36pt'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
      ></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
      ></dxi-item>
      <dxi-item
        name="header"
        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
      ></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item widget="dxButton" [options]="toolbarButtonOptionsClarificationText"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>
</div>

<h2 class="content-block">Kişisel Veriler ve Genel Gizlilik Sözleşmesi</h2>
<div class="content-block card responsive-paddings">
  <label span class="dx-field-item-label-text">Başlık</label>
  <dx-text-box
    [(value)]="informationTextRegardingTheProcessingOfPersonalData.title"
    labelMode="floating"
    [maxLength]="100"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaKeyword</label>
  <dx-text-box
    [(value)]="informationTextRegardingTheProcessingOfPersonalData.metaKeyword"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaDescription</label>
  <dx-text-box
    [(value)]="informationTextRegardingTheProcessingOfPersonalData.metaDescription"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
     <app-image-uploader
      (fileSelected)="onFileSelectedInformationTextRegardingTheProcessingOfPersonalData($event)"
      [src]="informationTextRegardingTheProcessingOfPersonalData.imageUrl"
    ></app-image-uploader>
    <br />
  <dx-html-editor
    [(value)]="informationTextRegardingTheProcessingOfPersonalData.content" style="height: 300px;"
  >
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item
        name="size"
        [acceptedValues]="[
          '8pt',
          '9pt',
          '10pt',
          '12pt',
          '14pt',
          '18pt',
          '24pt',
          '36pt'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
      ></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
      ></dxi-item>
      <dxi-item
        name="header"
        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
      ></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item widget="dxButton" [options]="toolbarButtonOptionsInformationTextRegardingTheProcessingOfPersonalData"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>
</div>

<h2 class="content-block">İptal ve İade Koşulları</h2>
<div class="content-block card responsive-paddings">
  <label span class="dx-field-item-label-text">Başlık</label>
  <dx-text-box
    [(value)]="cancellationAndRefund.title"
    labelMode="floating"
    [maxLength]="100"
  >
  </dx-text-box>
  <br />
    <label span class="dx-field-item-label-text">MetaKeyword</label>
    <dx-text-box
      [(value)]="cancellationAndRefund.metaKeyword"
      labelMode="floating"
    >
    </dx-text-box>
    <br />
    <label span class="dx-field-item-label-text">MetaDescription</label>
    <dx-text-box
      [(value)]="cancellationAndRefund.metaDescription"
      labelMode="floating"
    >
    </dx-text-box>
  <br />
       <app-image-uploader
      (fileSelected)="onFileSelectedCancellationAndRefund($event)"
      [src]="cancellationAndRefund.imageUrl"
    ></app-image-uploader>
    <br />
  <dx-html-editor [(value)]="cancellationAndRefund.content" style="height: 300px;">
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item
        name="size"
        [acceptedValues]="[
          '8pt',
          '9pt',
          '10pt',
          '12pt',
          '14pt',
          '18pt',
          '24pt',
          '36pt'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
      ></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
      ></dxi-item>
      <dxi-item
        name="header"
        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
      ></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item widget="dxButton" [options]="toolbarButtonOptionsCancellationAndRefund"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>
</div>

<!-- <h2 class="content-block">Çerez Politikaları</h2>
<div class="content-block card responsive-paddings">
  <label span class="dx-field-item-label-text">Başlık</label>
  <dx-text-box
    [(value)]="cookiePolicy.title"
    labelMode="floating"
    [maxLength]="100"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaKeyword</label>
  <dx-text-box
    [(value)]="cookiePolicy.metaKeyword"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaDescription</label>
  <dx-text-box
    [(value)]="cookiePolicy.metaDescription"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
  <dx-html-editor [(value)]="cookiePolicy.content" style="height: 300px;">
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item
        name="size"
        [acceptedValues]="[
          '8pt',
          '9pt',
          '10pt',
          '12pt',
          '14pt',
          '18pt',
          '24pt',
          '36pt'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
      ></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana'
        ]"
        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
      ></dxi-item>
      <dxi-item
        name="header"
        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
      ></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link" ></dxi-item>
      <dxi-item widget="dxButton" [options]="toolbarButtonOptionsCookiePolicy"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>
</div> -->

<dx-popup
  [showTitle]="true"
  title="Ön İzleme"
  [(visible)]="popupVisibleTermsAndConditions"
  [showCloseButton]="true"
>
  <h3>{{ termsAndConditions.title }}</h3>
  <div [innerHTML]="termsAndConditions.content"></div>
</dx-popup>

<dx-popup
  [showTitle]="true"
  title="Ön İzleme"
  [(visible)]="popupVisibleClarificationText"
  [showCloseButton]="true"
>
  <h3>{{ clarificationText.title }}</h3>
  <div [innerHTML]="clarificationText.content"></div>
</dx-popup>

<dx-popup
  [showTitle]="true"
  title="Ön İzleme"
  [(visible)]="popupVisibleInformationTextRegardingTheProcessingOfPersonalData"
  [showCloseButton]="true"
>
  <h3>{{ informationTextRegardingTheProcessingOfPersonalData.title }}</h3>
  <div [innerHTML]="informationTextRegardingTheProcessingOfPersonalData.content"></div>
</dx-popup>

<!-- <dx-popup
  [showTitle]="true"
  title="Ön İzleme"
  [(visible)]="popupVisibleCookiePolicy"
  [showCloseButton]="true"
>
  <h3>{{ cookiePolicy.title }}</h3>
  <div [innerHTML]="cookiePolicy.content"></div>
</dx-popup> -->
</div>